import React, { useEffect, useState } from "react";
const AddConsultings = () => {
  return <div></div>;
};

export default AddConsultings;
